var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"navigation-item",attrs:{"active-class":"navigation-item--active","to":_vm.to}},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }